export enum ANIMATION_KEYS {
  ENVELOPE = 'ENVELOPE',
  HEARTS = 'HEARTS',
  CONFETTI = 'CONFETTI',
  NONE = 'NONE',
}

interface AnimationOptions {
  emoji: string;
  key: string;
  text: string;
}

interface AnimationOptionsMap {
  [key: string]: AnimationOptions;
}

export const ANIMATION_OPTIONS: AnimationOptionsMap = {
  [ANIMATION_KEYS.ENVELOPE]: {
    emoji: '💌',
    key: ANIMATION_KEYS.ENVELOPE,
    text: "You've got mail!",
  },
  [ANIMATION_KEYS.HEARTS]: {
    emoji: '✨',
    key: ANIMATION_KEYS.HEARTS,
    text: 'Love is in the air',
  },
  [ANIMATION_KEYS.CONFETTI]: {
    emoji: '🎉',
    key: ANIMATION_KEYS.CONFETTI,
    text: 'Get this party started',
  },
  [ANIMATION_KEYS.NONE]: {
    emoji: '',
    key: ANIMATION_KEYS.NONE,
    text: 'None',
  },
};
